import { useColorMode } from '@chakra-ui/react';
import React from 'react';
import { getColorThemeSelector } from '../../../utils/funcs';
import PathIcon from '../PathIcon/PathIcon';

interface Props {
    isHovering: boolean;
}

const LightModeIcon: React.FC<Props> = ({ isHovering }) => {
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);

    return (
        <PathIcon
            isHovering={isHovering}
            pathClassesMap={{
                norm: colorTheme(['light-btn-light-h'], ['light-btn-dark']),
                hover: colorTheme(['light-btn-light-h'], ['light-btn-dark-h']),
            }}
            paths={[
                'M18.05,3.05a.92.92,0,0,1,.64.26.91.91,0,0,1,0,1.29L17.41,5.88a.9.9,0,0,1-.64.26.89.89,0,0,1-.91-.91.86.86,0,0,1,.26-.63L17.4,3.31a.92.92,0,0,1,.65-.26Zm1.1,7H21a.91.91,0,1,1,0,1.82H19.15a.87.87,0,0,1-.64-.27.92.92,0,0,1,0-1.28A.87.87,0,0,1,19.15,10.09ZM11,.13a.9.9,0,0,1,.64.26.89.89,0,0,1,.27.64V2.85a.87.87,0,0,1-.27.64.89.89,0,0,1-1.28,0,.87.87,0,0,1-.27-.64V1a.89.89,0,0,1,.27-.64A.9.9,0,0,1,11,.13ZM4,3.05a.92.92,0,0,1,.64.26L5.88,4.6a.84.84,0,0,1,.26.63.84.84,0,0,1-.26.64.87.87,0,0,1-.64.27.91.91,0,0,1-.65-.26L3.31,4.6A.91.91,0,0,1,3.05,4a.87.87,0,0,1,.27-.64A.88.88,0,0,1,4,3.05ZM16.77,15.86a.88.88,0,0,1,.64.26l1.28,1.28a.91.91,0,0,1,.27.65.89.89,0,0,1-.27.64.93.93,0,0,1-1.29,0L16.12,17.4a.86.86,0,0,1-.26-.63.9.9,0,0,1,.91-.91ZM11,7.38A3.62,3.62,0,0,0,7.38,11,3.62,3.62,0,0,0,11,14.62,3.62,3.62,0,0,0,14.62,11,3.62,3.62,0,0,0,11,7.38ZM1,10.09H2.85a.87.87,0,0,1,.64.27.92.92,0,0,1,0,1.28.87.87,0,0,1-.64.27H1a.91.91,0,1,1,0-1.82Zm10,8.16a.86.86,0,0,1,.64.26.87.87,0,0,1,.27.64V21a.87.87,0,0,1-.27.64.92.92,0,0,1-1.28,0,.87.87,0,0,1-.27-.64V19.15a.87.87,0,0,1,.27-.64.86.86,0,0,1,.64-.26ZM5.24,15.86a.86.86,0,0,1,.64.26.89.89,0,0,1,.27.65.83.83,0,0,1-.27.63L4.6,18.69A.88.88,0,0,1,4,19a.84.84,0,0,1-.64-.26.87.87,0,0,1-.27-.64.91.91,0,0,1,.26-.65l1.28-1.28a.88.88,0,0,1,.65-.26ZM11,5.56a5.37,5.37,0,0,1,2.73.73,5.53,5.53,0,0,1,2,2,5.47,5.47,0,0,1,0,5.46,5.53,5.53,0,0,1-2,2,5.47,5.47,0,0,1-5.46,0,5.53,5.53,0,0,1-2-2,5.47,5.47,0,0,1,0-5.46,5.53,5.53,0,0,1,2-2A5.37,5.37,0,0,1,11,5.56Z',
            ]}
            viewBox="0 0 22 22"
            height="25px"
            width="25px"
        />
    );
};

export default LightModeIcon;
